module.exports = "../fonts/black-plane copy 3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/black-plane copy 3.svg
// module id = 425
// module chunks = 0